/**
 * Centralized branding tokens for white-label support.
 * All brand-specific text should reference these defaults.
 * Backend can override via DesignConfiguration.
 */
function readBrandingEnvironment(key: string): string | undefined {
  const environment: unknown = import.meta.env;
  if (typeof environment !== 'object' || environment === null) return undefined;
  const value: unknown = Reflect.get(environment, key);
  return typeof value === 'string' && value.trim() !== '' ? value : undefined;
}

export const defaultBrandingTokens = {
  // Site Identity
  siteName: readBrandingEnvironment('VITE_SITE_NAME') ?? 'EroChat',
  siteTitle: readBrandingEnvironment('VITE_SITE_TITLE') ?? 'Erotic Chat Platform',
  metaDescription:
    readBrandingEnvironment('VITE_META_DESCRIPTION') ??
    'Erlebe authentische, leidenschaftliche Unterhaltungen mit einzigartigen Charakteren.',

  // Hero Section
  heroTitle: readBrandingEnvironment('VITE_HERO_TITLE') ?? 'Intime Gespräche',
  heroSubtitle:
    readBrandingEnvironment('VITE_HERO_SUBTITLE') ??
    'Erlebe authentische, leidenschaftliche Unterhaltungen mit einzigartigen Charakteren.',

  // CTA Buttons
  primaryCTA: readBrandingEnvironment('VITE_PRIMARY_CTA') ?? 'Jetzt heiss chatten',
  secondaryCTA: readBrandingEnvironment('VITE_SECONDARY_CTA') ?? 'Kostenlos registrieren',

  // Theme
  themeName: readBrandingEnvironment('VITE_THEME_NAME') ?? 'Purple Passion Premium',

  // Preset Author (for white-label)
  presetAuthor: readBrandingEnvironment('VITE_PRESET_AUTHOR') ?? 'Design System Team',
} as const;

export type BrandingTokens = typeof defaultBrandingTokens;
